import { render, staticRenderFns } from "./RevisionObservation.vue?vue&type=template&id=8935aee6&scoped=true"
import script from "./RevisionObservation.vue?vue&type=script&lang=js"
export * from "./RevisionObservation.vue?vue&type=script&lang=js"
import style0 from "./RevisionObservation.vue?vue&type=style&index=0&id=8935aee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8935aee6",
  null
  
)

export default component.exports